export interface StatamicTaxonomy {
    title: string
    handle: string
    url?: string
}

export interface StatamicTerm {
    id: string
    url?: string
    slug?: string
    title: string
    taxonomy: StatamicTaxonomy
    order?: number
}

export interface StatamicTaxonomyTermsRequest {
    taxonomy: string
}

export interface StatamicTaxonomyTermsResponse<T> {
    data: T[]
}

export const useStatamicTaxonomies = () => {
    const statamic = useStatamic()

    const getTaxonomyTerms = async <T extends StatamicTerm = StatamicTerm>(
        data: StatamicTaxonomyTermsRequest,
    ) =>
        await statamic<StatamicTaxonomyTermsResponse<T>>(`taxonomies/${data.taxonomy}/terms`, {
            transform: (data: T[]) => {
                if (data.length > 0 && data[0].hasOwnProperty('order')) {
                    return data.sort((a, b) => {
                        if (a.order && b.order) {
                            return a.order - b.order
                        }

                        return 0
                    })
                }

                return data
            },
        })

    return {
        getTaxonomyTerms,
    }
}
